export const searchProductsParams = /* GraphQL */ `{
  term: $term,
  sort: $sort,
  filters: {
    department: $department,
    sub_categories: $sub_categories,
    brands: $brands,
    brands_quantity: $brands_quantity,
    size_types: $size_types,
    price_max: $price_max,
    price_min: $price_min,
    used: $used,
    shipping_range: $shipping_range,
    city: $city,
    state: $state,
    promotion_slug: $promotion_slug,
    seller_segmentation: $seller_segmentation,
    last_published_at: $last_published_at,
    published_before: $published_before,
    exposure: $exposure,
    experienced_seller: $experienced_seller,
    plan_id: $plan_id,
    discount_percentage_min: $discount_percentage_min,
    discount_percentage_max: $discount_percentage_max,
    store_kind: $store_kind
  }
}`
